import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AvailableDocuments from '../AvailableDocuments';
import { BarChart3, Trash2, Upload } from 'lucide-react';
import DeleteConfirmationModal from '../DeleteConfirmationModal';
import PanelButton from '../PanelButton';

const DocumentsContent = ({
  autoPopulateExpanded,
  directoryPath,
  setDirectoryPath,
  handleAutoPopulate,
  databaseLoading,
  databaseErrors,
  hasAvailableDocuments,
  masterDocuments,
  proposalDocuments,
  noteDocuments,
  securityDocuments,
  handlePreviewDocument,
  setAutoPopulateExpanded,
  handleAnalyzeDocuments,
  handleClearResults,
  handlePermanentlyDeleteResults,
  loading,
  loanId
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const navigate = useNavigate();
  
  return (
    <>
      {/* Auto-populate section */}
      <div style={{ marginBottom: '1rem' }}>
        {autoPopulateExpanded && (
          <div style={{ padding: '1rem', background: '#f8f9fa', borderRadius: '4px', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
              <input
                type="text"
                placeholder="Enter directory path..."
                value={directoryPath}
                onChange={(e) => setDirectoryPath(e.target.value)}
                style={{
                  flex: 1,
                  padding: '0.5rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '4px',
                  fontSize: '0.875rem'
                }}
              />
              <button
                onClick={handleAutoPopulate}
                disabled={databaseLoading.autoPopulate || !directoryPath.trim()}
                style={{
                  padding: '0.5rem 1rem',
                  background: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '0.875rem',
                  opacity: databaseLoading.autoPopulate || !directoryPath.trim() ? 0.5 : 1
                }}
              >
                {databaseLoading.autoPopulate ? 'Loading...' : 'Auto-Populate'}
              </button>
            </div>
            {databaseErrors.autoPopulate && (
              <div style={{ color: '#dc2626', fontSize: '0.875rem' }}>
                Error: {databaseErrors.autoPopulate}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Documents section */}
      {hasAvailableDocuments ? (
        <AvailableDocuments
          masterDocuments={masterDocuments}
          proposalDocuments={proposalDocuments}
          noteDocuments={noteDocuments}
          securityDocuments={securityDocuments}
          onPreviewDocument={handlePreviewDocument}
          onToggleAutoPopulate={() => setAutoPopulateExpanded(!autoPopulateExpanded)}
          autoPopulateExpanded={autoPopulateExpanded}
          showAutoPopulate={true}
        />
      ) : (
        <div style={{ padding: '2rem', textAlign: 'center', color: '#6b7280' }}>
          <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>📁</div>
          <div style={{ fontSize: '1rem', fontWeight: '500', marginBottom: '0.5rem' }}>
            No documents available
          </div>
          <div style={{ fontSize: '0.875rem' }}>
            Upload files or use auto-populate to add documents for this loan.
          </div>
        </div>
      )}

      {/* Action buttons */}
      <div style={{ 
        marginTop: '1.5rem', 
        paddingTop: '1.5rem', 
        borderTop: '1px solid #4a4a4a',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem'
      }}>
        {/* Hidden for now - Analyze Documents button */}
        {/* <button
          onClick={handleAnalyzeDocuments}
          disabled={loading?.analyze}
          style={{
            width: '100%',
            padding: '0.75rem 1rem',
            background: loading?.analyze ? '#6b7280' : '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: loading?.analyze ? 'not-allowed' : 'pointer',
            fontSize: '0.875rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            opacity: loading?.analyze ? 0.6 : 1,
            transition: 'all 0.2s'
          }}
        >
          <BarChart3 size={16} />
          {loading?.analyze ? 'Analyzing...' : 'Analyze Documents'}
        </button> */}
        
        <PanelButton onClick={() => {
          console.log('Upload Files clicked, loanId:', loanId);
          navigate(`/document-analysis/${loanId}/scans`);
        }}>
          <Upload size={16} />
          Upload Files
        </PanelButton>
        
        <PanelButton
          deleteMode={true}
          onClick={() => setShowDeleteModal(true)}
        >
          <Trash2 size={16} />
          Permanently Delete Results
        </PanelButton>
      </div>
      
      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => {
          handlePermanentlyDeleteResults(loanId);
          setShowDeleteModal(false);
        }}
        loanId={loanId}
        isLoading={loading?.deleteResults}
      />
    </>
  );
};

export default DocumentsContent;
